import { EMPTY_STRING } from '../../../constants/common'
import { toMessageTemplateSelectItem } from '../../MessageTemplate'

export function getChatroomTemplateAuthorLabel(value) {
  return `(${value?.created_by?.fullname || EMPTY_STRING})`
}

export function toChatroomTemplateSelectItem(item) {
  return {
    ...toMessageTemplateSelectItem(item),
    additionalData: getChatroomTemplateAuthorLabel(item),
    private: item.private,
  }
}

export function toChatroomTemplateSelectItems(
  items,
  mapper = toChatroomTemplateSelectItem
) {
  return items.map(mapper)
}

export function isChatroomTemplatePublic(option) {
  return !option?.private
}
